module.exports = __webpack_public_path__ + "static/media/img-background1.c19ab189.jpg";